export default {
  meta: {
    public: false,
    auth: true,
    icon: "fa-cog",
    expanded: false,
    label: "Settings",
    permission: [config.permission.DASHBOARD_SETTINGS_INDEX]
  },
  children: [
    {
      name: "General Setting",
      path: "/general_setting",
      meta: {
        label: "General ",
        breadcrumb: [{ name: "General" }],
        permission: [config.permission.ADVANCED_SETTINGS_INDEX]
      },
      component: () => import("views/advanced_settings/general/index")
    },
    {
      name: "Advanced Settings",
      path: "/advanced_settings",
      meta: {
        label: "Advanced Settings",

        permission: [config.permission.ADVANCED_SETTINGS_INDEX]
      },
      component: () => import("views/advanced_settings/index")
    },
    {
      name: "Supplier",
      path: "/supplier",
      meta: {
        label: "Suppliers",
        breadcrumb: [{ name: "Suppliers" }],
        permission: [config.permission.SUPPLIERS_INDEX]
      },
      component: () => import("views/supplier/index")
    },
    {
      name: "supplier_create",
      path: "create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [
          { name: "Suppliers", link: "/supplier" },
          { name: "Create" }
        ]
      },
      component: () => import("views/supplier/create")
    },
    {
      name: "supplier_edit",
      path: "edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Suppliers", link: "/supplier" }]
      },
      component: () => import("views/supplier/edit"),
      props: true
    },
    // // Plan
    // {
    //   name: "Plan",
    //   path: "/plan",
    //   meta: {
    //     label: "Plans",
    //     auth: true,
    //
    //     permission: [
    //       config.permission.PLANS_INDEX
    //     ]
    //   },
    //   component: () => import("views/plan/index")
    // },
    // {
    //   name: "plangroup_create",
    //   path: "/plan/create_group",
    //   meta: {
    //     auth: true,
    //     label: "Create ",
    //     breadcrumb: [{ name: "Create", link: "/plan?tab=plan_groups" }]
    //   },
    //   component: () => import("views/plan/group/create")
    // },
    // {
    //   name: "plan_create",
    //   path: "/plan/create",
    //   meta: {
    //     auth: true,
    //     label: "Create ",
    //     breadcrumb: [{ name: "Create", link: "/plan?tab=plans" }]
    //   },
    //   component: () => import("views/plan/create")
    // },
    // {
    //   name: "plan_edit",
    //   path: "/plan/edit/:id",
    //   meta: {
    //     auth: true,
    //     label: "Edit ",
    //     breadcrumb: [{ link: "/plan?tab=plans" }]
    //   },
    //   component: () => import("views/plan/edit")
    // },
    {
      name: "VAT",
      path: "/gst",
      meta: {
        label: "VAT",
        breadcrumb: [{ name: "VAT" }],
        permission: [config.permission.GSTS_INDEX]
      },
      component: () => import("views/gst/index")
    },
    // VAT
    {
      name: "Create VAT",
      path: "/gst/create",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [{ name: "VAT", link: "/gst" }, { name: "Create" }],
        label: "Create VAT"
      },
      component: () => import("views/gst/create")
    },
    {
      name: "Edit VAT",
      path: "/gst/edit/:id",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [{ name: "VAT", link: "/gst" }],
        label: "Edit VAT"
      },
      component: () => import("views/gst/edit")
    },
    {
      name: "Currencies",
      path: "/currency",
      meta: {
        label: "Currencies",

        permission: [config.permission.CURRENCIES_INDEX]
      },
      component: () => import("views/currency/index")
    },
    {
      name: "Create Currency",
      path: "/currency/create",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [{ name: "Create", link: "/currency?tab=currencies" }],
        label: "Create Currency"
      },
      component: () => import("views/currency/create")
    },
    {
      name: "Edit Currency",
      path: "/currency/edit/:id",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [{ name: "Currencies", link: "/currency?tab=currencies" }],
        label: "Edit Currency"
      },
      component: () => import("views/currency/edit")
    },
    {
      name: "Create Currency Rate",
      path: "/currency/create_rate",
      meta: {
        public: false,
        auth: true,
        breadcrumb: [{ name: "Create", link: "/currency?tab=currency_rates" }],
        label: "Create Currency Rate"
      },
      component: () => import("views/currency/create_rate")
    },
    {
      name: "Delivery Fee",
      path: "/delivery_fee",
      meta: {
        label: "Delivery Fee",
        breadcrumb: [{ name: "Delivery Fees" }],
        permission: [config.permission.SETTINGS_INDEX]
      },
      component: () => import("views/delivery_fee/index")
    },
    // Product entry
    {
      name: "Product Entry",
      path: "/product_entry",
      meta: {
        label: "Product Entry",
        permission: [config.permission.PRODUCT_ENTRIES_INDEX]
      },
      component: () => import("views/setting/product_entry/index")
    },
    {
      name: "Loyalty Programs",
      path: "/loyalty_programs",
      meta: {
        label: "Loyalty Programs",
        permission: [config.permission.SETTINGS_INDEX]
      },
      component: () => import("views/setting/loyalty/index")
    },
    {
      name: "Delivery Slot",
      path: "/delivery",
      meta: {
        public: false,
        auth: true,
        label: "Delivery Slot",
        icon: "fa-truck",
        breadcrumb: [{ name: "Delivery Slots" }],
        permission: [config.permission.DELIVERY_SLOTS_INDEX]
      },
      component: () => import("views/delivery/index")
    },
    {
      name: "Newsletters",
      path: "/newsletter",
      meta: {
        public: false,
        auth: true,
        icon: "fa-envelope",
        breadcrumb: [{ name: "Newsletters" }],
        permission: [config.permission.NEWSLETTERS_INDEX]
      },
      component: () => import("views/newsletter/index")
    },
    {
      name: "birthday_mails",
      path: "/birthday_mail",
      meta: {
        label: "Birthday Mails",
        breadcrumb: [{ name: "Birthday Mails" }],
        permission: [config.permission.BIRTHDAY_MAIL_INDEX]
      },
      component: () => import("views/birthday_mail/index")
    },
    // {
    //   name: "Greeting Card",
    //   path: "/greeting_card",
    //   meta: {
    //     label: "Greeting Card",
    //     breadcrumb: [{ name: "Greeting Card" }],
    //     permission: [config.permission.SETTINGS_INDEX]
    //   },
    //   component: () => import("views/greeting_card/index")
    // },
    {
      name: "Product Add-ons",
      path: "/product_addons",
      meta: {
        label: "Product Add-ons",
        permission: [config.permission.PRODUCT_ENTRIES_INDEX]
      },
      component: () => import("views/setting/product_addons/index")
    },
    {
      name: "vivinofeed",
      path: "/vivino",
      meta: {
        label: "Vivino Feed",
        breadcrumb: [{ name: "Vivino Feed" }],
        permission: [config.permission.VIVINO_FEEDING_INDEX]
      },
      component: () => import("views/vivino/index")
    }
  ]
};
